import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton, FlexStack } from '~/components/atomic';

interface NoMyPageItemMessageProps {
  message: string;
  buttonTitle: string;
  onButtonClick: () => void;
}

export default function NoMyPageItemMessage({
  message,
  buttonTitle,
  onButtonClick,
}: NoMyPageItemMessageProps) {
  return (
    <FlexStack
      css={css`
        flex: 1;
        align-items: center;
        justify-content: center;
        gap: 32px;
      `}
    >
      <Message>{message}</Message>
      <div
        css={css`
          width: 250px;
        `}
      >
        <DefaultButton onClick={onButtonClick}>{buttonTitle}</DefaultButton>
      </div>
    </FlexStack>
  );
}

const Message = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_2};
    ${theme.fontStyle.poppins.desc2_bold};
  `}
`;
